/* global axios */
import ApiClient from './ApiClient';

class RemindersAPI extends ApiClient {
  constructor() {
    super('reminders', { accountScoped: true });
  }

  clearTriggered() {
    return axios.delete(`${this.url}/clear_triggered`);
  }
}

export default new RemindersAPI();
